export default __webpack_public_path__ + "static/media/thumb-default.83b83fcd.png";